/** @file NumericRow: a labelled row of numeric fields: the unit once, and a reason line when disabled. */
import type { ReactElement, ReactNode } from 'react';

/** Row `label`, its `unit` (shown once as `label (unit)`), the fields as children, and why they are disabled (if they are). */
export type NumericRowProps = { label: string; unit?: string; reason?: string | null; children: ReactNode };

/** The label column is fixed so every row's fields line up; the reason sits under the row as visible small text. */
export function NumericRow(props: NumericRowProps): ReactElement {
  const reason = props.reason ?? null;
  return (
    <div data-row={props.label}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <span style={{ width: 92, flex: 'none', color: 'var(--p3-muted, #8b919e)', overflowWrap: 'anywhere' }}>
          {props.unit === undefined ? props.label : `${props.label} (${props.unit})`}
        </span>
        {props.children}
      </div>
      {reason !== null && (
        <div data-reason={props.label} style={{ paddingLeft: 96, fontSize: 10, color: 'var(--p3-muted, #8b919e)', overflowWrap: 'anywhere' }}>{reason}</div>
      )}
    </div>
  );
}
